import React from 'react';
import { useOpportunitySearch } from '../../../hooks/useOpportunitySearch';
import { SalesforceRef } from '../../../support/assessments';
import SalesforceLookupAutocomplete from './SalesforceLookupAutocomplete';

/** Answer input for a `sf_opportunity` question — search a Salesforce Opportunity by name or id. */
const SalesforceOpportunityLookupInput: React.FC<{
  value: SalesforceRef | null;
  onChange: (value: SalesforceRef | null) => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled }) => {
  const { term, setTerm, results, isLoading } = useOpportunitySearch();
  return (
    <SalesforceLookupAutocomplete
      label="Salesforce Opportunity"
      placeholder="Search opportunities by name or id"
      value={value}
      onChange={onChange}
      term={term}
      onTermChange={setTerm}
      options={results}
      loading={isLoading}
      disabled={disabled}
    />
  );
};

export default SalesforceOpportunityLookupInput;
